import { useDispatch } from 'react-redux';
import { IconButton, Tooltip, TableCell } from '@material-ui/core';
import { showMessage } from 'app/store/fuse/messageSlice';
import PlayArrow from '@material-ui/icons/PlayArrow';
import TaskManagerService from 'app/admin/taskManager/service/TaskManagerService';

function TaskManagerPlayButton(props) {
    const dispatch = useDispatch();

    const start = e => {
        TaskManagerService.runOnDemand(props.item.id).then(resp => {
            dispatch(showMessage({ message: props.item.name + ' run request submitted' }));
        });
    };

    return (
        <TableCell className='w-auto text-center' padding='none'>

            <Tooltip title='Start'>
                <span>
                    <IconButton disabled={!!props.item.schedule} onClick={e => { start(true); e.preventDefault(); }}>
                        <PlayArrow fontSize='small' />
                    </IconButton>
                </span>
            </Tooltip>

        </TableCell>
    );
}

export default TaskManagerPlayButton;